var exports = {
  "HS": "VoiceE2EEIndicator.module__indicatorBase___VkFPSC",
  "QS": "VoiceE2EEIndicator.module__indicatorEncrypted___VkFPSC" + " " + "VoiceE2EEIndicator.module__indicatorBase___VkFPSC",
  "pP": "VoiceE2EEIndicator.module__indicatorBroken___VkFPSC" + " " + "VoiceE2EEIndicator.module__indicatorBase___VkFPSC",
  "Gm": "VoiceE2EEIndicator.module__indicatorP2p___VkFPSC" + " " + "VoiceE2EEIndicator.module__indicatorEncrypted___VkFPSC" + " " + "VoiceE2EEIndicator.module__indicatorBase___VkFPSC",
  "RQ": "VoiceE2EEIndicator.module__indicatorP2pBroken___VkFPSC" + " " + "VoiceE2EEIndicator.module__indicatorBroken___VkFPSC" + " " + "VoiceE2EEIndicator.module__indicatorBase___VkFPSC",
};

module.exports = exports;
